import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource-variable/inter";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./setupSentry";

const container = document.getElementById("root") as HTMLElement;
const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Prerendered pages ship with content inside #root — hydrate instead of
// re-rendering so the crawler-visible HTML doubles as the first paint.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree, {
    // Snapshot prerendering (unlike real SSR) merges adjacent JSX text nodes
    // when the HTML is reparsed, so React reports a recoverable mismatch and
    // re-renders the identical content client-side. Expected — keep it quiet
    // in production, surface it in development.
    onRecoverableError: (error) => {
      if (process.env.NODE_ENV !== "production") {
        console.warn("Hydration recovered:", error);
      }
    },
  });

  // The prerender inlined Emotion's CSS into <style data-prerender> tags so
  // first paint is styled. Hydration just re-inserted identical rules into
  // Emotion's own runtime tags, so drop the snapshot duplicates once idle.
  const removeSnapshotCss = () => {
    document.querySelectorAll("style[data-prerender]").forEach((el) => el.remove());
  };
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(removeSnapshotCss);
  } else {
    window.setTimeout(removeSnapshotCss, 2000);
  }
} else {
  ReactDOM.createRoot(container).render(tree);
}

// Service worker removed: a caching SW risks serving stale prerendered shells
// after deploys. unregister() also cleans up previously installed workers.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
